export enum LaboratoryRequestItemType {
	TAB_CONTAINER = 'tabContainer',
	TAB = 'tab',
	GROUP = 'group',
	GROUP_CHECKBOX = 'groupCheckbox',
	CHECKBOX = 'checkbox',
	CONTAINER = 'container',
	TEXT_FIELD = 'textField',
	TITLE = 'title',
	SUB_TITLE = 'subtitle',
	SPACE = 'space',
	RADIO_LIST = 'radioList',
	TEXT_AREA = 'textArea',
	CONDITION = 'condition',
}
